<div mat-dialog-title>Update Dispatch System</div>
<div *ngIf="dispatchSystemStatus$ | async as status" mat-dialog-content>
  <p class="mb-4">
    Current system: <strong>{{ getCurrentSystemName(status) }}</strong>
  </p>

  <div *ngIf="status.warnings?.length" class="border border-red-400 rounded-l p-3 mb-4">
    <div *ngFor="let warning of status.warnings; trackBy: trackByWarning" class="text-lg">
      {{ warning }}
    </div>
  </div>

  <mat-form-field class="w-full">
    <mat-label>Dispatch System</mat-label>
    <mat-select [formControl]="selectedSystemFC">
      <mat-select-trigger>
        {{ getSystemDisplayName(selectedSystemFC.value) }}
      </mat-select-trigger>
      <mat-option
        *ngFor="let system of status.availableSystems; trackBy: trackByValue"
        [value]="system.value"
        [disabled]="system.disabled"
      >
        {{ system.displayName }}
        <span *ngIf="system.hint" class="text-gray-600 text-sm block">{{ system.hint }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div
    *ngIf="getSelectedSystemHint()"
    class="mt-2 text-gray-600 text-sm border-l-4 border-gray-300 pl-3 py-2 bg-gray-50"
  >
    {{ getSelectedSystemHint() }}
  </div>
</div>
<div *ngIf="dispatchSystemStatus$ | async as status" mat-dialog-actions>
  <button mat-button mat-dialog-close="">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedSystemFC.value || selectedSystemFC.value === status.currentSystem || (networkActive$ | async)"
    (click)="updateDispatchSystem()"
  >
    Update Dispatch System
  </button>
</div>
